import { getTypographyMetric, getTypographyMetricOverride } from '../../../../../../helpers';
import { useTheme } from 'styled-components';
import { Flex } from 'front-commons/ds/components/Flex';
import { Icon } from 'front-commons/ds/components';
import { Typography } from 'hype-ds';
import { getTriggerLabels } from './helpers';
import { TriggerProps } from '../../interfaces';

export function Trigger({ currentBalance, level, optIn, onClick }: TriggerProps) {
	const { fontSizes } = useTheme();

	const { title, subtitle } = getTriggerLabels({ currentBalance, level, optIn });

	return (
		<Flex
			display="flex"
			gap="0.25rem"
			padding="0.25rem 0.5rem"
			alignItems="center"
			whiteSpace="nowrap"
			borderRadius="4px"
			cursor="pointer"
			transition="all 300ms ease"
			raw={{ '&:hover': { backgroundColor: 'var(--surface-accent-light)' } }}
			data-testid="trigger-fidelity"
			onClick={onClick}
			width="120px"
		>
			<Icon name="boniLogo" size="24px" color="--boni-purple700" />

			<Flex
				raw={{
					"[data-header-text='Trigger-text-1']": {
						display: 'inline',
						fontSize: getTypographyMetricOverride(fontSizes['16']),
						lineHeight: getTypographyMetricOverride(fontSizes['24']),
					},
					"[data-header-text='Trigger-text-2']": {
						display: 'inline',
						fontSize: getTypographyMetricOverride(fontSizes['12']),
						lineHeight: getTypographyMetricOverride(fontSizes['16']),
					},
				}}
				display="flex"
				gap="normal"
				direction="column"
				alignItems="flex-start"
			>
				<Typography
					textAlign="inherit"
					fontSize={getTypographyMetric(fontSizes['16'])}
					fontWeight="600"
					lineHeight={getTypographyMetric(fontSizes['24'])}
					color="#782EC5"
					data-header-text="Trigger-text-1"
				>
					{title}
				</Typography>
				<Typography
					textAlign="inherit"
					fontSize={getTypographyMetric(fontSizes['12'])}
					fontWeight="400"
					lineHeight={getTypographyMetric(fontSizes['16'])}
					color="--greys-700"
					data-header-text="Trigger-text-2"
				>
					{subtitle}
				</Typography>
			</Flex>
		</Flex>
	);
}
